module.exports = __webpack_public_path__ + "static/media/sell_resend_invoice_7.2d10ac47.jpg";